import {DataModificationsHeader} from 'audit/DataModifications';
import {CollaborationCreateOrUpdate, CollaborationCreate} from 'auth/PermissionConstants';
import * as net from 'util/Net';

export default {
  removeCollaborator(
    id: string,
    partyId: string,
    apiBase: string,
    dataModsHeader?: DataModificationsHeader
  ): Promise<{}> {
    return net.deletePromise({
      url: `${apiBase}/${id}/collaborators/${partyId}`,
      extraHeaders: dataModsHeader,
    });
  },

  updateCollaborations(
    id: string,
    collaborations: Array<CollaborationCreateOrUpdate>,
    apiBase: string,
    dataModsHeader?: DataModificationsHeader
  ): Promise<{}> {
    return net.patchJSONPromise({
      url: `${apiBase}/${id}/collaborations`,
      data: {collaborations},
      extraHeaders: dataModsHeader,
    });
  },

  createCollaborations(
    id: string,
    collaborations: Array<CollaborationCreate>,
    apiBase: string,
    dataModsHeader?: DataModificationsHeader
  ): Promise<{}> {
    return net.postJSONPromise({
      url: `${apiBase}/${id}/collaborations:bulk-create`,
      data: {collaborations},
      extraHeaders: dataModsHeader,
    });
  },

  deleteCollaborations(
    id: string,
    collaborationIds: Array<string>,
    apiBase: string,
    dataModsHeader?: DataModificationsHeader
  ): Promise<{}> {
    return net.deletePromise({
      url: `${apiBase}/${id}/collaborations:bulk-delete`,
      data: {collaborationIds},
      extraHeaders: dataModsHeader,
    });
  },
};
